// extracted by mini-css-extract-plugin
export default {"options-btn":"OptionsDropdown_options-btn__Nw7YD"};